import React from "react";
import PropTypes from "prop-types";
import { Icon, IconButton, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { DotsVerticalIcon } from "@heroicons/react/outline";

const DataTableActions = ({ children, ...props }) => {
  return (
    <Menu>
      <MenuButton
        _hover={{
          backgroundColor: "gray.100",
          color: "brand.primary.600",
        }}
        aria-label="Actions"
        icon={<Icon as={DotsVerticalIcon} fontSize="md" />}
        size="xs"
        variant="ghost"
        {...props}
        as={IconButton}
      />
      <MenuList>{children}</MenuList>
    </Menu>
  );
};

DataTableActions.propTypes = {
  children: PropTypes.node,
};

export default DataTableActions;
